export const portServiceDisplayNames: Record<string, string> = {
  '3com-njack-1': '3COM-NJACK-1',
  '3cx-tunnel': '3CX-TUNNEL',
  '3link': '3LINK',
  '914c-g': '914C-G',
  'CardWeb-IO': 'CardWeb-IO',
  DragonIDSConsole: 'DragonIDSConsole',
  'EtherNetIP-1': 'EtherNetIP-1',
  IIS: 'IIS',
  'LSA-or-nterm': 'LSA-or-nterm',
  'MOS-soap': 'MOS-soap',
  'NFS-or-IIS': 'NFS-or-IIS',
  X11: 'X11',
  'X11:1': 'X11:1',
  'X11:2': 'X11:2',
  'X11:3': 'X11:3',
  XmlIpcRegSvc: 'XmlIpcRegSvc',
  'a-trust-rpc': 'A-TRUST-RPC',
  aas: 'AAS',
  abyss: 'ABYSS',
  'accu-lmgr': 'ACCU-LMGR',
  'ace-server': 'ACE-SERVER',
  acme: 'ACME',
  'adi-gxp-srvprt': 'ADI-GXP-SRVPRT',
  admdog: 'ADMDOG',
  'adobe-crossdomain': 'ADOBE-CROSSDOMAIN',
  adws: 'ADWS',
  'afs3-bos': 'AFS3-BOS',
  'afs3-callback': 'AFS3-CALLBACK',
  'afs3-errors': 'AFS3-ERRORS',
  'afs3-fileserver': 'AFS3-FILESERVER',
  'afs3-prserver': 'AFS3-PRSERVER',
  'afs3-rmtsys': 'AFS3-RMTSYS',
  'afs3-vlserver': 'AFS3-VLSERVER',
  'afs3-volser': 'AFS3-VOLSER',
  agentview: 'AGENTVIEW',
  alfin: 'ALFIN',
  'almobile-system': 'ALMOBILE-SYSTEM',
  amandaidx: 'AMANDAIDX',
  amberon: 'AMBERON',
  amqp: 'AMQP',
  amqps: 'AMQPS',
  ams: 'AMS',
  'anet-b': 'ANET-B',
  anynetgateway: 'ANYNETGATEWAY',
  apani1: 'APANI1',
  apani2: 'APANI2',
  apani3: 'APANI3',
  apani4: 'APANI4',
  apani5: 'APANI5',
  'apc-9951': 'APC-9951',
  'apollo-data': 'APOLLO-DATA',
  'apsolab-col': 'APSOLAB-COL',
  'apsolab-cols': 'APSOLAB-COLS',
  arcserve: 'ARCSERVE',
  'arena-server': 'ARENA-SERVER',
  armcenterhttp: 'ARMCENTERHTTP',
  armcenterhttps: 'ARMCENTERHTTPS',
  armtechdaemon: 'ARMTECHDAEMON',
  'asf-rmcp': 'ASF-RMCP',
  asmps: 'ASMPS',
  asterisk: 'ASTERISK',
  asterix: 'ASTERIX',
  aurora: 'AURORA',
  aurp: 'AURP',
  'autodesk-nlm': 'AUTODESK-NLM',
  avantageb2b: 'AVANTAGEB2B',
  'bandwidth-test': 'BANDWIDTH-TEST',
  'barracuda-bbs': 'BARRACUDA-BBS',
  'bbn-mmx': 'BBN-MMX',
  'bex-xr': 'BEX-XR',
  bgp: 'BGP',
  'bittorrent-tracker': 'BITTORRENT-TRACKER',
  'blackice-alerts': 'BLACKICE-ALERTS',
  'blackice-icecap': 'BLACKICE-ICECAP',
  bngsync: 'BNGSYNC',
  bo2k: 'BO2K',
  bolt: 'BOLT',
  boxp: 'BOXP',
  'brlp-0': 'BRLP-0',
  'brlp-1': 'BRLP-1',
  'brlp-2': 'BRLP-2',
  'brlp-3': 'BRLP-3',
  bvcontrol: 'BVCONTROL',
  'ca-mq': 'CA-MQ',
  'ca-web-update': 'CA-WEB-UPDATE',
  caacws: 'CAACWS',
  cacsambroker: 'CACSAMBROKER',
  cadlock: 'CADLOCK',
  'cadview-3d': 'CADVIEW-3D',
  callwaveiam: 'CALLWAVEIAM',
  'carrius-rshell': 'CARRIUS-RSHELL',
  cbt: 'CBT',
  'ccproxy-http': 'CCPROXY-HTTP',
  cddbp: 'CDDBP',
  'cddbp-alt': 'CDDBP-ALT',
  cesdcdman: 'CESDCDMAN',
  'cfg-cloud': 'CFG-CLOUD',
  cfs: 'CFS',
  chargen: 'CHARGEN',
  check_mk: 'CHECK_MK',
  'checkmk-agent': 'CHECKMK-AGENT',
  chlenix: 'CHLENIX',
  cimple: 'CIMPLE',
  'ciphire-serv': 'CIPHIRE-SERV',
  cirrossp: 'CIRROSSP',
  'cisco-aqos': 'CISCO-AQOS',
  'cisco-sccp': 'CISCO-SCCP',
  'cisco-snat': 'CISCO-SNAT',
  classic: 'CLASSIC',
  cleverdetect: 'CLEVERDETECT',
  'cmtp-mgt': 'CMTP-MGT',
  'commtact-http': 'COMMTACT-HTTP',
  'commtact-https': 'COMMTACT-HTTPS',
  controlit: 'CONTROLIT',
  copy: 'COPY',
  copycat: 'COPYCAT',
  'cr-websystems': 'CR-WEBSYSTEMS',
  'cruise-update': 'CRUISE-UPDATE',
  cslistener: 'CSLISTENER',
  csms2: 'CSMS2',
  ctdp: 'CTDP',
  ctechlicensing: 'CTECHLICENSING',
  cumulus: 'CUMULUS',
  custix: 'CUSTIX',
  cvc_hostd: 'CVC_HOSTD',
  'd-star': 'D-STAR',
  d2dconfig: 'D2DCONFIG',
  d2ddatatrans: 'D2DDATATRANS',
  'danf-ak2': 'DANF-AK2',
  'data-insurance': 'DATA-INSURANCE',
  datalens: 'DATALENS',
  daytime: 'DAYTIME',
  'db-lsp': 'DB-LSP',
  dbabble: 'DBABBLE',
  dbsyncarbiter: 'DBSYNCARBITER',
  dc: 'DC',
  dddp: 'DDDP',
  'ddi-tcp-2': 'DDI-TCP-2',
  'ddi-tcp-3': 'DDI-TCP-3',
  'ddm-rdb': 'DDM-RDB',
  'ddm-ssl': 'DDM-SSL',
  'decvms-sysmgt': 'DECVMS-SYSMGT',
  descent3: 'DESCENT3',
  'dey-sapi': 'DEY-SAPI',
  dhanalakshmi: 'DHANALAKSHMI',
  dhcps: 'DHCPS',
  diagmond: 'DIAGMOND',
  'directv-catlg': 'DIRECTV-CATLG',
  'directv-soft': 'DIRECTV-SOFT',
  'dist-upgrade': 'DIST-UPGRADE',
  distinct32: 'DISTINCT32',
  dls: 'DLS',
  dnox: 'DNOX',
  dnp: 'DNP',
  dns: 'DNS',
  docker: 'DOCKER',
  documentum: 'DOCUMENTUM',
  domain: 'DOMAIN',
  'domain-s': 'DOMAIN-S',
  'dots-signal': 'DOTS-SIGNAL',
  down: 'DOWN',
  'dpm-agent': 'DPM-AGENT',
  dpserve: 'DPSERVE',
  dpserveadmin: 'DPSERVEADMIN',
  dtpt: 'DTPT',
  dvbservdsc: 'DVBSERVDSC',
  dynamid: 'DYNAMID',
  echo: 'ECHO',
  ecmp: 'ECMP',
  efcp: 'EFCP',
  eklogin: 'EKLOGIN',
  eli: 'ELI',
  elpro_tunnel: 'ELPRO_TUNNEL',
  'emc-pp-mgmtsvc': 'EMC-PP-MGMTSVC',
  emcsymapiport: 'EMCSYMAPIPORT',
  'enguity-xccetp': 'ENGUITY-XCCETP',
  'eor-game': 'EOR-GAME',
  epmd: 'EPMD',
  epnsdp: 'EPNSDP',
  epp: 'EPP',
  equationbuilder: 'EQUATIONBUILDER',
  ergolight: 'ERGOLIGHT',
  'erp-scale': 'ERP-SCALE',
  esmagent: 'ESMAGENT',
  'etcd-client': 'ETCD-CLIENT',
  'etcd-server': 'ETCD-SERVER',
  'exoline-tcp': 'EXOLINE-TCP',
  'ezproxy-2': 'EZPROXY-2',
  ezrelay: 'EZRELAY',
  'f5-iquery': 'F5-IQUERY',
  femis: 'FEMIS',
  filemaker: 'FILEMAKER',
  filezilla: 'FILEZILLA',
  finger: 'FINGER',
  firebird: 'FIREBIRD',
  'fisa-svc': 'FISA-SVC',
  fjdmimgr: 'FJDMIMGR',
  flexlm: 'FLEXLM',
  flexlm0: 'FLEXLM0',
  'fln-spx': 'FLN-SPX',
  'fmpro-v6': 'FMPRO-V6',
  fmproduct: 'FMPRODUCT',
  fmsas: 'FMSAS',
  fmsascon: 'FMSASCON',
  fmtp: 'FMTP',
  'font-service': 'FONT-SERVICE',
  fpitp: 'FPITP',
  frcs: 'FRCS',
  'fsc-port': 'FSC-PORT',
  ftp: 'FTP',
  ftps: 'FTPS',
  'fujitsu-dtcns': 'FUJITSU-DTCNS',
  'fw1-topology': 'FW1-TOPOLOGY',
  'g-data-sec': 'G-DATA-SEC',
  gadgetgate2way: 'GADGETGATE2WAY',
  galaxy4d: 'GALAXY4D',
  'gbs-stp': 'GBS-STP',
  'gcm-app': 'GCM-APP',
  gds_db: 'GDS_DB',
  giop: 'GIOP',
  globe: 'GLOBE',
  glrpc: 'GLRPC',
  'gnmi-gnoi': 'GNMI-GNOI',
  gnunet: 'GNUNET',
  gnutella: 'GNUTELLA',
  'goldleaf-licman': 'GOLDLEAF-LICMAN',
  grasp: 'GRASP',
  grcmp: 'GRCMP',
  grcp: 'GRCP',
  gribi: 'GRIBI',
  grpc: 'GRPC',
  gsms: 'GSMS',
  gue: 'GUE',
  guibase: 'GUIBASE',
  gw: 'GW',
  'gwen-sonya': 'GWEN-SONYA',
  gxtelmd: 'GXTELMD',
  h323q931: 'H323Q931',
  'hacl-local': 'HACL-LOCAL',
  heathview: 'HEATHVIEW',
  'hes-clip': 'HES-CLIP',
  hfcs: 'HFCS',
  'hik-connect': 'HIK-CONNECT',
  'hosts2-ns': 'HOSTS2-NS',
  hotline: 'HOTLINE',
  hpvirtgrp: 'HPVIRTGRP',
  http: 'HTTP',
  'http-alt': 'HTTP-ALT',
  'http-proxy': 'HTTP-PROXY',
  https: 'HTTPS',
  'https-alt': 'HTTPS-ALT',
  'https-wmap': 'HTTPS-WMAP',
  hydap: 'HYDAP',
  'hyperscsi-port': 'HYPERSCSI-PORT',
  'i3-sessionmgr': 'I3-SESSIONMGR',
  iad2: 'IAD2',
  'ias-reg': 'IAS-REG',
  'ibm-db2-admin': 'IBM-DB2-ADMIN',
  'ibm-rsyscon': 'IBM-RSYSCON',
  icabrowser: 'ICABROWSER',
  'icl-twobase1': 'ICL-TWOBASE1',
  icpp: 'ICPP',
  icpps: 'ICPPS',
  icpv2: 'ICPV2',
  idmaps: 'IDMAPS',
  'ies-lm': 'IES-LM',
  'igi-lm': 'IGI-LM',
  'igo-incognito': 'IGO-INCOGNITO',
  iiimsf: 'IIIMSF',
  ill: 'ILL',
  imap: 'IMAP',
  imaps: 'IMAPS',
  imip: 'IMIP',
  'imip-channels': 'IMIP-CHANNELS',
  infowave: 'INFOWAVE',
  ingreslock: 'INGRESLOCK',
  'iniserve-port': 'INISERVE-PORT',
  inovaport4: 'INOVAPORT4',
  insis: 'INSIS',
  inspect: 'INSPECT',
  inspider: 'INSPIDER',
  'insteon-plm': 'INSTEON-PLM',
  interwise: 'INTERWISE',
  'intu-ec-svcdisc': 'INTU-EC-SVCDISC',
  iop: 'IOP',
  ipcam: 'IPCAM',
  ipdcesgbs: 'IPDCESGBS',
  iperf3: 'IPERF3',
  ipp: 'IPP',
  irdmi2: 'IRDMI2',
  irisa: 'IRISA',
  iscsi: 'ISCSI',
  isdd: 'ISDD',
  'isoipsigport-1': 'ISOIPSIGPORT-1',
  'isysg-lm': 'ISYSG-LM',
  'itm-mcell-u': 'ITM-MCELL-U',
  'j-ac': 'J-AC',
  jabber: 'JABBER',
  'java-rmi': 'JAVA-RMI',
  jdwp: 'JDWP',
  'jeol-nsdtp-4': 'JEOL-NSDTP-4',
  jetcmeserver: 'JETCMESERVER',
  jetdirect: 'JETDIRECT',
  'jtnetd-server': 'JTNETD-SERVER',
  jwpc: 'JWPC',
  'jwpc-bin': 'JWPC-BIN',
  jwserver: 'JWSERVER',
  kafka: 'KAFKA',
  'kerberos-sec': 'KERBEROS-SEC',
  'konshus-lm': 'KONSHUS-LM',
  kpasswd5: 'KPASSWD5',
  kpdp: 'KPDP',
  'ktickets-rest': 'KTICKETS-REST',
  kx: 'KX',
  'kz-migr': 'KZ-MIGR',
  'l2c-control': 'L2C-CONTROL',
  'l2c-data': 'L2C-DATA',
  l2f: 'L2F',
  'labtech-redirector': 'LABTECH-REDIRECTOR',
  'landesk-rc': 'LANDESK-RC',
  'lanner-lm': 'LANNER-LM',
  ldap: 'LDAP',
  ldaps: 'LDAPS',
  ldapssl: 'LDAPSSL',
  'ldoms-migr': 'LDOMS-MIGR',
  'libp2p-multistream': 'LIBP2P-MULTISTREAM',
  litecoin: 'LITECOIN',
  'lm-dta': 'LM-DTA',
  'lm-x': 'LM-X',
  lotusnotes: 'LOTUSNOTES',
  lpar2rrd: 'LPAR2RRD',
  'lxi-evntsvc': 'LXI-EVNTSVC',
  'm-oap': 'M-OAP',
  m2ua: 'M2UA',
  'matrix-fed': 'MATRIX-FED',
  mbap: 'MBAP',
  'mc-client': 'MC-CLIENT',
  'mc-nmf': 'MC-NMF',
  mciautoreg: 'MCIAUTOREG',
  mcreport: 'MCREPORT',
  'mcs-messaging': 'MCS-MESSAGING',
  mdbs_daemon: 'MDBS_DAEMON',
  'med-ltp': 'MED-LTP',
  mediat: 'MEDIAT',
  mep: 'MEP',
  metasys: 'METASYS',
  mevent: 'MEVENT',
  mice: 'MICE',
  microsan: 'MICROSAN',
  'microsoft-ds': 'MICROSOFT-DS',
  'microtalon-dis': 'MICROTALON-DIS',
  minecraft: 'MINECRAFT',
  minirem: 'MINIREM',
  miroconnect: 'MIROCONNECT',
  'mit-dov': 'MIT-DOV',
  'mit-ml-dev': 'MIT-ML-DEV',
  'ml-svnet': 'ML-SVNET',
  'mlchat-proxy': 'MLCHAT-PROXY',
  mmcc: 'MMCC',
  'mobrien-chat': 'MOBRIEN-CHAT',
  mon: 'MON',
  mongod: 'MONGOD',
  mongodb: 'MONGODB',
  'mosquitto version 2.0.21': 'mosquitto version 2.0.21',
  mountd: 'MOUNTD',
  mphlpdmc: 'MPHLPDMC',
  mpidcmgr: 'MPIDCMGR',
  mqtt: 'MQTT',
  'ms-licensing': 'MS-LICENSING',
  'ms-lsa': 'MS-LSA',
  'ms-sql-s': 'MS-SQL-S',
  'ms-sql2000': 'MS-SQL2000',
  'ms-v-worlds': 'MS-V-WORLDS',
  'ms-wbt-server': 'MS-WBT-SERVER',
  'msexchange-logcopier': 'MSEXCHANGE-LOGCOPIER',
  'msfw-replica': 'MSFW-REPLICA',
  msgclnt: 'MSGCLNT',
  msmq: 'MSMQ',
  msrpc: 'MSRPC',
  mssql: 'MSSQL',
  'mtl8000-matrix': 'MTL8000-MATRIX',
  multidropper: 'MULTIDROPPER',
  munin: 'MUNIN',
  murmur: 'MURMUR',
  'must-backplane': 'MUST-BACKPLANE',
  mxit: 'MXIT',
  mysql: 'MYSQL',
  mysqlx: 'MYSQLX',
  n2h2server: 'N2H2SERVER',
  n2receive: 'N2RECEIVE',
  'na-localise': 'NA-LOCALISE',
  nameserver: 'NAMESERVER',
  'nati-svrloc': 'NATI-SVRLOC',
  'nbx-dir': 'NBX-DIR',
  'nbx-ser': 'NBX-SER',
  ncacn_http: 'NCACN_HTTP',
  'ncd-conf': 'NCD-CONF',
  'ndm-agent-port': 'NDM-AGENT-PORT',
  net2display: 'NET2DISPLAY',
  netbackup: 'NETBACKUP',
  'netbios-ssn': 'NETBIOS-SSN',
  netscript: 'NETSCRIPT',
  'netspeak-acd': 'NETSPEAK-ACD',
  'netview-aix-6': 'NETVIEW-AIX-6',
  'netview-aix-7': 'NETVIEW-AIX-7',
  'netview-aix-8': 'NETVIEW-AIX-8',
  neveroffline: 'NEVEROFFLINE',
  newoak: 'NEWOAK',
  'nexus-portal': 'NEXUS-PORTAL',
  nfs: 'NFS',
  'niagara-fox': 'NIAGARA-FOX',
  nimgtw: 'NIMGTW',
  nlockmgr: 'NLOCKMGR',
  nomdb: 'NOMDB',
  'novell-ipx-cmd': 'NOVELL-IPX-CMD',
  'npmp-trap': 'NPMP-TRAP',
  'nq-ap': 'NQ-AP',
  'nsw-fe': 'NSW-FE',
  'nucleus-sand': 'NUCLEUS-SAND',
  ocs_cmu: 'OCS_CMU',
  oftp: 'OFTP',
  'ogs-client': 'OGS-CLIENT',
  'oma-mlp-s': 'OMA-MLP-S',
  omapi: 'OMAPI',
  'onep-tls': 'ONEP-TLS',
  onscreen: 'ONSCREEN',
  opentelemetry: 'OPENTELEMETRY',
  openvpn: 'OPENVPN',
  'opsession-prxy': 'OPSESSION-PRXY',
  oracle: 'ORACLE',
  'oracle-tns': 'ORACLE-TNS',
  'oracleas-https': 'ORACLEAS-HTTPS',
  orasrv: 'ORASRV',
  'osm-appsrvr': 'OSM-APPSRVR',
  osp: 'OSP',
  'ospf-lite': 'OSPF-LITE',
  osxwebadmin: 'OSXWEBADMIN',
  otp: 'OTP',
  'ov-nnm-websrv': 'OV-NNM-WEBSRV',
  'p.service': 'P.SERVICE',
  p2pevolvenet: 'P2PEVOLVENET',
  p6ssmc: 'P6SSMC',
  pads: 'PADS',
  'pago-services1': 'PAGO-SERVICES1',
  'palace-6': 'PALACE-6',
  'panagolin-ident': 'PANAGOLIN-IDENT',
  'pando-pub': 'PANDO-PUB',
  'papachi-p2p-srv': 'PAPACHI-P2P-SRV',
  paragent: 'PARAGENT',
  patrol: 'PATROL',
  'patrol-snmp': 'PATROL-SNMP',
  'paycash-online': 'PAYCASH-ONLINE',
  'paycash-wbp': 'PAYCASH-WBP',
  pcoip: 'PCOIP',
  'pcsync-http': 'PCSYNC-HTTP',
  pdap: 'PDAP',
  'pdap-np': 'PDAP-NP',
  pegasus: 'PEGASUS',
  'pegasus-ctl': 'PEGASUS-CTL',
  'perf-port': 'PERF-PORT',
  pgps: 'PGPS',
  pharos: 'PHAROS',
  pichat: 'PICHAT',
  picodbc: 'PICODBC',
  pmcd: 'PMCD',
  'pnet-conn': 'PNET-CONN',
  pop3: 'POP3',
  pop3s: 'POP3S',
  postgresql: 'POSTGRESQL',
  ppactivation: 'PPACTIVATION',
  ppp: 'PPP',
  pptp: 'PPTP',
  printer: 'PRINTER',
  'prm-sm-np': 'PRM-SM-NP',
  prnrequest: 'PRNREQUEST',
  prnstatus: 'PRNSTATUS',
  'profinet-rt': 'PROFINET-RT',
  'proshare-mc-1': 'PROSHARE-MC-1',
  'ptp-event': 'PTP-EVENT',
  pumpkindb: 'PUMPKINDB',
  pushns: 'PUSHNS',
  pvuniwien: 'PVUNIWIEN',
  pwgwims: 'PWGWIMS',
  'pxc-ntfy': 'PXC-NTFY',
  'pxc-pin': 'PXC-PIN',
  'pxc-roid': 'PXC-ROID',
  'pxc-splr': 'PXC-SPLR',
  'pxc-splr-ft': 'PXC-SPLR-FT',
  'pxc-spvr': 'PXC-SPVR',
  q3ade: 'Q3ADE',
  qcp: 'QCP',
  'qemu-vlan': 'QEMU-VLAN',
  qotd: 'QOTD',
  'qsnet-nucl': 'QSNET-NUCL',
  quantastor: 'QUANTASTOR',
  'quest-data-hub': 'QUEST-DATA-HUB',
  quicksuite: 'QUICKSUITE',
  'r1soft-cdp': 'R1SOFT-CDP',
  'radan-http': 'RADAN-HTTP',
  radsec: 'RADSEC',
  'radware-rpm': 'RADWARE-RPM',
  rancher: 'RANCHER',
  'rap-listen': 'RAP-LISTEN',
  'rap-service': 'RAP-SERVICE',
  rcst: 'RCST',
  rdp: 'RDP',
  realserver: 'REALSERVER',
  redis: 'REDIS',
  remoteanything: 'REMOTEANYTHING',
  remoting: 'REMOTING',
  'reverse-ssl': 'REVERSE-SSL',
  rfe: 'RFE',
  ridgeway1: 'RIDGEWAY1',
  rise: 'RISE',
  'rjcdb-vcards': 'RJCDB-VCARDS',
  rmiaux: 'RMIAUX',
  rmonitor_secure: 'RMONITOR_SECURE',
  'rockwell-csp1': 'ROCKWELL-CSP1',
  'rockwell-csp2': 'ROCKWELL-CSP2',
  rome: 'ROME',
  rpc: 'RPC',
  rpcbind: 'RPCBIND',
  rrac: 'RRAC',
  'rsf-1': 'RSF-1',
  rsqlserver: 'RSQLSERVER',
  rsync: 'RSYNC',
  'rt-sound': 'RT-SOUND',
  'rt-viewer': 'RT-VIEWER',
  rtmp: 'RTMP',
  rtsp: 'RTSP',
  'rtsp-alt': 'RTSP-ALT',
  rwhois: 'RWHOIS',
  rxmon: 'RXMON',
  's-bfd': 'S-BFD',
  sac: 'SAC',
  'sae-urn': 'SAE-URN',
  safetynetp: 'SAFETYNETP',
  'sage-best-com1': 'SAGE-BEST-COM1',
  'sage-best-com2': 'SAGE-BEST-COM2',
  sagxtsds: 'SAGXTSDS',
  sal: 'SAL',
  sapms: 'SAPMS',
  saprouter: 'SAPROUTER',
  sapv1: 'SAPV1',
  sbl: 'SBL',
  'scotty-disc': 'SCOTTY-DISC',
  'scotty-ft': 'SCOTTY-FT',
  'scp-config': 'SCP-CONFIG',
  'scpi-telnet': 'SCPI-TELNET',
  sdadmind: 'SDADMIND',
  sdr: 'SDR',
  'secure-cfg-svr': 'SECURE-CFG-SVR',
  'secure-mqtt': 'SECURE-MQTT',
  'secure-ts': 'SECURE-TS',
  serverstart: 'SERVERSTART',
  serverviewdbms: 'SERVERVIEWDBMS',
  'sharp-server': 'SHARP-SERVER',
  shiva_confsrvr: 'SHIVA_CONFSRVR',
  shofarplayer: 'SHOFARPLAYER',
  'shrewd-control': 'SHREWD-CONTROL',
  sieve: 'SIEVE',
  signiant: 'SIGNIANT',
  sip: 'SIP',
  'sip-proxy': 'SIP-PROXY',
  'sip-tls': 'SIP-TLS',
  'slm-api': 'SLM-API',
  slp: 'SLP',
  'sma-spw': 'SMA-SPW',
  'smart-install': 'SMART-INSTALL',
  'smart-lm': 'SMART-LM',
  smb: 'SMB',
  smpp: 'SMPP',
  smtp: 'SMTP',
  smtps: 'SMTPS',
  smux: 'SMUX',
  snapenetio: 'SNAPENETIO',
  snmp: 'SNMP',
  snpp: 'SNPP',
  'sns-gateway': 'SNS-GATEWAY',
  socks: 'SOCKS',
  'socks-proxy': 'SOCKS-PROXY',
  socks5: 'SOCKS5',
  'sometimes-rpc27': 'SOMETIMES-RPC27',
  sophos: 'SOPHOS',
  spark: 'SPARK',
  spc: 'SPC',
  sphinxapi: 'SPHINXAPI',
  sphinxql: 'SPHINXQL',
  splashtop: 'SPLASHTOP',
  'spss-lm': 'SPSS-LM',
  sqlexec: 'SQLEXEC',
  'sqlexec-ssl': 'SQLEXEC-SSL',
  'squid-http': 'SQUID-HTTP',
  src: 'SRC',
  'ss-idi': 'SS-IDI',
  'ss-idi-disc': 'SS-IDI-DISC',
  ssh: 'SSH',
  ssl: 'SSL',
  'sstp-2': 'SSTP-2',
  'stat-scanner': 'STAT-SCANNER',
  status: 'STATUS',
  stel: 'STEL',
  stmf: 'STMF',
  storview: 'STORVIEW',
  stt: 'STT',
  stun: 'STUN',
  sua: 'SUA',
  submission: 'SUBMISSION',
  'sun-answerbook': 'SUN-ANSWERBOOK',
  'sun-as-jpda': 'SUN-AS-JPDA',
  'sun-as-nodeagt': 'SUN-AS-NODEAGT',
  'sun-sr-https': 'SUN-SR-HTTPS',
  'sun-sr-jmx': 'SUN-SR-JMX',
  support: 'SUPPORT',
  surebox: 'SUREBOX',
  svn: 'SVN',
  svnserve: 'SVNSERVE',
  'swa-1': 'SWA-1',
  'swa-2': 'SWA-2',
  'swa-3': 'SWA-3',
  'swa-4': 'SWA-4',
  'swift-rvf': 'SWIFT-RVF',
  'swtp-port1': 'SWTP-PORT1',
  'swtp-port2': 'SWTP-PORT2',
  sybasesrvmon: 'SYBASESRVMON',
  symplex: 'SYMPLEX',
  synchronite: 'SYNCHRONITE',
  syncserverssl: 'SYNCSERVERSSL',
  synobtrfsreplicad: 'SYNOBTRFSREPLICAD',
  'syslog-conn': 'SYSLOG-CONN',
  'syslog-tls': 'SYSLOG-TLS',
  'talarian-mcast3': 'TALARIAN-MCAST3',
  'talarian-mcast5': 'TALARIAN-MCAST5',
  'talon-disc': 'TALON-DISC',
  'talon-engine': 'TALON-ENGINE',
  tambora: 'TAMBORA',
  'targus-getdata': 'TARGUS-GETDATA',
  'targus-getdata1': 'TARGUS-GETDATA1',
  'targus-getdata3': 'TARGUS-GETDATA3',
  'taurus-wh': 'TAURUS-WH',
  tcp: 'TCP',
  'tcp-id-port': 'TCP-ID-PORT',
  tcpwrapped: 'TCPWRAPPED',
  teamcoherence: 'TEAMCOHERENCE',
  teamviewer: 'TEAMVIEWER',
  telnet: 'TELNET',
  telnetcpcd: 'TELNETCPCD',
  teradataordbms: 'TERADATAORDBMS',
  textui: 'TEXTUI',
  time: 'TIME',
  tinc: 'TINC',
  tinymessage: 'TINYMESSAGE',
  tlisrv: 'TLISRV',
  tnp: 'TNP',
  'tomato-springs': 'TOMATO-SPRINGS',
  'tor-control': 'TOR-CONTROL',
  'tor-orport': 'TOR-ORPORT',
  'tor-socks': 'TOR-SOCKS',
  'tor-trans': 'TOR-TRANS',
  track: 'TRACK',
  traingpsdata: 'TRAINGPSDATA',
  tram: 'TRAM',
  trap: 'TRAP',
  trisoap: 'TRISOAP',
  trivnet1: 'TRIVNET1',
  trivnet2: 'TRIVNET2',
  'trusted-web': 'TRUSTED-WEB',
  tserver: 'TSERVER',
  tsrmagt: 'TSRMAGT',
  'ttc-ssl': 'TTC-SSL',
  'tungsten-https': 'TUNGSTEN-HTTPS',
  umeter: 'UMETER',
  'ums-webviewer': 'UMS-WEBVIEWER',
  unicall: 'UNICALL',
  unisql: 'UNISQL',
  unknown: 'UNKNOWN',
  upnp: 'UPNP',
  'ups-onlinet': 'UPS-ONLINET',
  'us-srv': 'US-SRV',
  'va-pacbase': 'VA-PACBASE',
  vad: 'VAD',
  vcscmd: 'VCSCMD',
  'veritas-ucl': 'VERITAS-UCL',
  veritas_pbx: 'VERITAS_PBX',
  'virtual-places': 'VIRTUAL-PLACES',
  visd: 'VISD',
  vmrdp: 'VMRDP',
  vmsvc: 'VMSVC',
  'vmware-auth': 'VMWARE-AUTH',
  'vmware-fdm': 'VMWARE-FDM',
  vnc: 'VNC',
  vnetd: 'VNETD',
  vop: 'VOP',
  vrace: 'VRACE',
  'vrml-multi-use': 'VRML-MULTI-USE',
  vrpn: 'VRPN',
  'vrts-tdd': 'VRTS-TDD',
  vsamredirector: 'VSAMREDIRECTOR',
  vstat: 'VSTAT',
  'vvr-data': 'VVR-DATA',
  'wap-vcal': 'WAP-VCAL',
  'wap-vcard': 'WAP-VCARD',
  'wap-vcard-s': 'WAP-VCARD-S',
  'wap-wsp': 'WAP-WSP',
  'wap-wsp-s': 'WAP-WSP-S',
  'wap-wsp-wtp': 'WAP-WSP-WTP',
  'wap-wsp-wtp-s': 'WAP-WSP-WTP-S',
  waste: 'WASTE',
  webpush: 'WEBPUSH',
  websnp: 'WEBSNP',
  websocket: 'WEBSOCKET',
  whosockami: 'WHOSOCKAMI',
  winbox: 'WINBOX',
  windb: 'WINDB',
  winrm: 'WINRM',
  'world-lm': 'WORLD-LM',
  'wsm-server-ssl': 'WSM-SERVER-SSL',
  wsman: 'WSMAN',
  wsmans: 'WSMANS',
  x11: 'X11',
  'x11:1': 'X11:1',
  'x9-icue': 'X9-ICUE',
  xfer: 'XFER',
  xgrid: 'XGRID',
  'xmltec-xmlmail': 'XMLTEC-XMLMAIL',
  xmms2: 'XMMS2',
  xmpp: 'XMPP',
  'xmpp-bosh': 'XMPP-BOSH',
  'xmpp-client': 'XMPP-CLIENT',
  'xmpp-transport': 'XMPP-TRANSPORT',
  xpilot: 'XPILOT',
  xycstatus: 'XYCSTATUS',
  'zabbix-agent': 'ZABBIX-AGENT',
  'zabbix-trapper': 'ZABBIX-TRAPPER',
  zebra: 'ZEBRA',
  'zephyr-clt': 'ZEPHYR-CLT',
  'zeus-admin': 'ZEUS-ADMIN',
  zmtp: 'ZMTP',
};
